import {_getOrderTypeFromBasket, _toMoney, getTrackingDataFromItem} from "../utils/utils";
import TrackerContract from "./tracker-contract"

let dataLayer = window.dataLayer || []

export default class GoogleAnalyticsTracker extends TrackerContract {

    constructor() {
        super()
        dataLayer.push({'property': process.env.VUE_APP_CONTEXT})
        dataLayer.push({'appVersion': process.env.VUE_APP_VERSION})
    }

    disabledIf(evt,params) {
        if (['ANDROID', 'HUAWEI_ANDROID', 'IOS'].includes(process.env.VUE_APP_CONTEXT)) return true
    }

    setUser(user) {
        const id = user.anonymous === true ? undefined : user.id
        const name = user.anonymous === true ? undefined : user.name
        dataLayer.push({'userId': id, 'name': name})
    }

    setAttributionData(payload) {
        if (['ANDROID', 'HUAWEI_ANDROID', 'IOS'].includes(process.env.VUE_APP_CONTEXT)) return
        dataLayer.push({'campaignName': payload.campaign})
        dataLayer.push({'campaignSource': payload.media_source})
        dataLayer.push({'campaignMedium': payload.media_medium})
    }

    productImpressions(productImpressions) {
        _track('productImpressions', null, {
            impressions: productImpressions
        })
    }

    productClick(product, category) {
        let data = getTrackingDataFromItem(product)
        data.category = category
        _track('productClick', 'click', {
            products: [data]
        })
    }

    productView(product) {
        _track('productView', 'detail', {
            products: [getTrackingDataFromItem(product)]
        })
    }

    addToCart(products) { /* Products or GiftCards */
        products = Array.isArray(products) ? products : [products]

        _track('addToCart', 'add', {
            products: products.map((product) => getTrackingDataFromItem(product))
        })
    }

    removeFromCart(basketItem) {
        _track('removeFromCart', 'remove', {
            products: [getTrackingDataFromItem(basketItem)]
        })
    }

    checkout(step, basket) {
        let data = {
            actionField: {
                step: step,
            }
        }

        if (basket) {
            data.products = basket.items.map(getTrackingDataFromItem)
        }
        if (['ANDROID', 'HUAWEI_ANDROID'].includes(process.env.VUE_APP_CONTEXT)) return // disable these events in this context to avoid duplicates bwetween firebase

        _track('checkout', 'checkout', data)
    }

    paymentOption(paymentSource, paymentAmount, isMultiPartPayment) {
        _trackUserAction('paymentOption', {
            paymentOption: paymentSource,
            optionRevenue: _toMoney(paymentAmount),
            paymentType: isMultiPartPayment ? 'PARTIAL' : 'FULL',
        })
    }

    purchase(transactionId, basket, affiliation) {

        let data = {
            products: basket.items.map(getTrackingDataFromItem),
            actionField: {
                id: transactionId,
                revenue: _toMoney(basket.totalPrice),
                shipping: basket.deliveryPrice ? _toMoney(basket.deliveryPrice) : undefined,
                tax: _toMoney(basket.totalVat),
                orderType: _getOrderTypeFromBasket(basket),
                affiliation,
            },
        }

        // if (['ANDROID', 'HUAWEI_ANDROID'].includes(process.env.VUE_APP_CONTEXT)) return // disable these events in this context to avoid duplicates bwetween firebase

        _track('purchase', 'purchase', data)
    }

    search(path, query) {
        this.pageView(path)

        const params = {
            search_term: query['query'],
            search_ctx: query['search-ctx'],
        }

        _trackUserAction('search', params)
    }

    pageView(path) {
        _trackUserAction('VirtualPageview', {
            virtualPageURL: path,
            virtualPageTitle: 'Nandos',
        })
    }

    addPaymentInfo() {
        _trackUserAction('paymentInfo', {label: 'add'})
    }

    signUp(method) {
        _trackUserAction('signUp', {label: method})
    }

    login(method) {
        _trackUserAction('login', {label: method})
    }
}


/**
 * Used to track e-commerce events
 */
function _track(eventName, eventLabel, data = {}) {

    let payload = {event: eventName}
    // Place the data onto the payload
    if (eventLabel) payload['ecommerce'] = {[eventLabel]: data}
    else payload['ecommerce'] = data

    dataLayer.push(payload)
}

/**
 * Used to track non-e-commerce events
 */
function _trackUserAction(eventName, data = {}) {
    dataLayer.push(Object.assign({
        event: eventName,
        ecommerce: undefined, // drop e-commerce data from previous calls - https://www.simoahava.com/gtm-tips/remember-to-flush-unused-data-layer-variables/
    }, data))
}